import * as Yup from 'yup';
import { DictionaryBalanceUnit } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryBalanceUnit>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
